import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function subscriptionListReducer(
  state = initialState.subsList ? initialState.subsList : null,
  action
) {
  switch (action.type) {
    case types.GET_SUBS_SUCCESS:
      return action.subs;
    case types.GET_SUBS_FAILED:
      return action.error;
    default:
      return state;
  }
}
